module.exports = __webpack_public_path__ + "static/media/PG.50b57a36.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/PG.svg
// module id = 2237
// module chunks = 7